var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.134308 25.3831C0.134308 10.4571 11.1228 0.166016 25.4437 0.166016C39.7646 0.166016 49.7532 10.4571 49.7532 25.3831C49.7532 33.0827 45.0186 37.5723 40.1853 39.0827C35.4152 40.5733 32.0812 39.1132 28.7672 35.3321H28.7585L28.7137 35.2709C27.545 33.9286 26.3779 32.2981 25.1501 30.407L21.5788 35.3321H14.2686L21.1636 25.1794L14.4345 14.9988H21.9777L25.1513 20.6201L28.1251 14.9988H35.7354L28.8056 25.1515L32.2871 30.2418L33.2524 31.6532C37.2117 36.726 44.0269 33.0315 44.0269 25.2823C44.0269 13.9869 35.8314 5.9188 25.4437 5.9188C14.9552 5.9188 5.60193 13.3707 5.60193 24.666C5.10193 34.8327 12.1853 45.5827 29.1853 44.4993L30.6853 49.4993C16.1853 51.416 0.134308 44.4993 0.134308 25.3831Z",
    fill: "#1A2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmtp);
export default __webpack_public_path__ + "static/media/xmtp.900a2866427985ee0d566bc1caf79ca3.svg";
export { ForwardRef as ReactComponent };